import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getFileUrl } from '../../lib/api';
import { heroImgClass, heroHeightClass } from '../../lib/heroFit';

export const HeroSliderV6 = ({ slides = [] }) => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    if (slides.length > 0) setCurrent(prev => (prev + 1) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    if (isPaused || slides.length <= 1) return;
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [isPaused, nextSlide, slides.length]);

  if (slides.length === 0) return (
    <div className="w-full h-[80vh] bg-[#0f1419] flex items-center justify-center">
      <p className="text-gray-500">Slider görsel eklenmemiş</p>
    </div>
  );

  const slide = slides[current];
  const fit = slide.fit_mode;

  return (
    <div className="w-full bg-[#0f1419]" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-testid="home-hero-carousel-v6">
      {/* Main Image */}
      <div className={`relative w-full ${heroHeightClass(fit, 'h-[60vh]', 'md:h-[70vh]')} overflow-hidden`}>
        <img src={getFileUrl(slide.image_path)} alt={slide.title} className={`${heroImgClass(fit)} transition-opacity duration-700`} key={current} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0f1419] via-transparent to-[#0f1419]/30" />

        {/* Centered Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          {slide.title && (
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-3 drop-shadow-lg max-w-3xl">
              {slide.title}
            </h1>
          )}
          {slide.subtitle && (
            <p className="text-sm sm:text-base text-white/70 mb-6 max-w-xl">{slide.subtitle}</p>
          )}
          {slide.link && (
            <Link to={slide.link} className="px-8 py-3 bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm rounded-lg hover:bg-[hsl(var(--gold)/0.9)] transition-colors">
              {slide.button_text || 'Detayları Gör'}
            </Link>
          )}
        </div>
      </div>

      {/* Thumbnail Strip */}
      {slides.length > 1 && (
        <div className="max-w-5xl mx-auto px-4 py-4">
          <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
            {slides.map((s, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`relative shrink-0 w-28 h-20 md:w-36 md:h-24 rounded-lg overflow-hidden transition-all duration-300 ${
                  i === current
                    ? 'ring-2 ring-[hsl(var(--gold))] opacity-100 scale-105'
                    : 'opacity-50 hover:opacity-75'
                }`}
              >
                <img src={getFileUrl(s.image_path)} alt={s.title} className="w-full h-full object-cover" />
                {i === current && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[hsl(var(--gold))]" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
